<ion-text color="gc-green" class="flex ion-align-items-center" *ngIf="(permissions | hasPermissions: 'work-order.item.price:view')">
  <strong data-cy="change-order-item-total-public">{{ item.total | currency }}</strong>
  <!--   TODO:: @Daniel here's a sketch of adding the uom when the ITL is not yet matched. -->
  <ion-badge color="medium" class="ion-margin-start">{{ item.unitOfMeasureSymbol }}</ion-badge>
</ion-text>
